import { useMemo } from "react";
import useKeycloakContext from "@wf/keycloak-axios-provider/dist/es/src/hooks/useKeycloakContext";
import { PROFILE_URL } from "../../../constants";

const authDefaultConfig = {
  isAuthenticated: false,
  username: "",
  handleLogin: () => {},
  handleLogout: () => {},
  handleViewProfile: () => {}
};

function useAuthConfig() {
  const keycloakContext = useKeycloakContext();

  const authConfig = useMemo(() => {
    if (!keycloakContext) {
      return authDefaultConfig;
    }
    const { isAuthenticated } = keycloakContext;
    let username = "";
    const userData = keycloakContext.getUserData() || {};

    if (isAuthenticated) {
      const { firstName } = userData;
      if (firstName) {
        username = `${userData.firstName} ${userData.lastName ? userData.lastName : ""}`;
      } else {
        username = userData.username;
      }
    }
    return {
      isAuthenticated,
      username,
      handleLogin: keycloakContext.login,
      handleLogout: keycloakContext.logout,
      handleViewProfile: () => {
        window.open(PROFILE_URL);
      }
    };
  }, [keycloakContext]);

  return {
    authConfig,
    isKeycloakInitialized: !!keycloakContext
  };
}

export default useAuthConfig;
